import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}><g transform="translate(-1 -1)" fillRule="nonzero" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 12V6M12 12H7.5" /></g></svg>);